/** 
    页面的title keywords  description配置
**/
let metaInfoUtils={
    "/":{//首页
		title: 'AI智慧食堂-食品溯源-生鲜食材配送-校园食品安全-华略未来科技',
		meta: [
		{
			name: "keywords",
			// content: "AI食堂,智慧食堂,食品溯源,生鲜配送,食材配送,校园食品安全"
			content: "智慧食安、食堂监管、团餐管理、食材集中配送、校园食品安全、食堂后厨安全、明厨亮灶、智慧食堂"
		},{
			name: "description",
			content: "华略未来科技有限公司是一家基于信息技术与人工智能的食安方案提供商,企业专注于AI智慧食堂,食品溯源,食材配送,生鲜配送,校园食品安全等,为客户,监管部门提供极具竞争力的产品方案和服务."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/'
        }]
	},
    
    //软件产品
    "/softwareproducts/purchase":{//采购溯源系统
		title: '采购溯源系统-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "食材溯源、采购商城、食堂采购平台、区块链溯源、集采集配、生鲜配送、大宗配送、营养餐配送、营养餐资金监管、一码溯源"
		},{
			name: "description",
			content: "利用电商平台在溯源方面的天生优势，为区域食品安全管理提供一套多用户、多供应商、 多重价格的食材物资定点采购平台，供、销双方通过“云平台”实现采购、销售。通过平台实..."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/softwareproducts/purchase'
        }]
	},//
    "/softwareproducts/canteen":{//食堂管理系统
		title: '食堂管理系统-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "食堂管理、明厨亮灶、AI分析、食堂进销存、食堂安全管理、燃气泄露"
		},{
			name: "description",
			content: "利用物联网、人工智能等技术手段和装备，从人、物、菜三个方面实现对食堂运营的智能化管理， 实现食品材料入库、粗加工、切配、烹饪、留样、出餐、餐饮具清洗消毒、废弃物管..."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/softwareproducts/canteen'
        }]
	},//
    "/softwareproducts/bigdata":{//大数据监管系统
		title: '大数据监管系统-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "大数据监管系统、校园食安大数据、集采大数据、采购大数据、食堂运营大数据"
		},{
			name: "description",
			content: "监管系统可以将采购溯源及食堂运营管理所获取的数据进行分析、呈现、对食品安全风险进行预警， 为监管单位防止食品安全事故发生和科学决策提供数据支撑。助力构建严密高效..."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/softwareproducts/bigdata'
        }]
	},//
    "/softwareproducts/train":{//培训系统
		title: '培训系统-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "食品安全培训平台、在线学习平台、在线培训、在线活动、新闻发布、食堂操作规范、食品安全员培训、食堂管理员培训"
		},{
			name: "description",
			content: "在线培训系统是为提高从业人员食品安全意识，学习食品安全相关知识及技能而设计。通过在线学习、在线考试、在线颁证等功能，利用智能手机、平板电脑等设备随时随地进行学习..."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/softwareproducts/train'
        }]
	},//

    //智能硬件
    "/equipment/dzc":{//电子智能秤
		title: '电子智能秤-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "智能电子秤、收货电子秤、防作弊电子秤、无线蓝牙电子秤、安卓电子秤"
		},{
			name: "description",
			content: "彻底告别人工下单、纸质对帐，杜绝人为失误；食堂、供应商下单、收货、对帐更轻松；收货拍照留痕、采购管理更透明"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/dzc'
        }]
	},//
    "/equipment/cjy":{//晨检仪
		title: '晨检仪-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "晨检仪、体温检测、人脸识别、AI晨检、考勤机"
		},{
			name: "description",
			content: "人脸识别考勤，自动统计分析 同步；体温筛查，超温报警"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/cjy'
        }]
	},//
    "/equipment/sjfx":{//AI视觉分析
		title: 'AI视觉分析-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "食堂违规分析、AI分析、口罩分析、工作服分析、厨师帽分析"
		},{
			name: "description",
			content: "可分析7种常见违规行为；自动抓拍留痕；量化分级管理、自动预警提示"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/sjfx'
        }]
	},//
    "/equipment/znlyg":{//智能留样柜
		title: '智能留样柜-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "智能留样柜、留样监管、留样冰箱、食品留样、留样安全、食堂留样"
		},{
			name: "description",
			content: "云端留样，随时可查可控，智能管控，确保安全规范。"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/znlyg'
        }]
	},//
    "/equipment/nckjy":{//农产快检仪
		title: '农产快检仪-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "农残检测仪、蔬菜检测、农药残留检测、瘦肉精检测"
		},{
			name: "description",
			content: "快速检测、自动判断；数据云端保存、自动关联溯源。"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/nckjy'
        }]
	},//
    "/equipment/xxgsp":{//信息公示屏
		title: '信息公示屏-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "学校食堂信息公示、健康证公示、采购记录公示、收货记录公示、经营许可证公示、液晶大屏、触摸互动一体机"
		},{
			name: "description",
			content: "展现形式多样、展示内容丰富"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/equipment/xxgsp'
        }]
	},//

    //解决方案
    "/solution/uci-enterprise":{//城投企业
		title: '城投企业-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "区域后勤综合服务平台、城投后勤、集中配送、教育后勤服务、食材配送、食堂托管、后勤托管、劳务派遣"
		},{
			name: "description",
			content: "华略帮助合作伙伴打造区域一体化的教育后勤服务综合管理平台，协助伙伴取得教育后勤服务经营、管理的行政授权，并为项目落地、实施提供咨询服务，助力伙伴成长为当地教育后勤服务龙头企业。"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/solution/uci-enterprise'
        }]
	},//
    "/solution/e-ms-bureau":{//教育局/市监局
		title: '教育局/市监局-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "区域食安监管方案、县级食安平台、市级食安平台、教育后勤管理"
		},{
			name: "description",
			content: "华略协助主管部门打造区域校园食堂食品安全监管系统平台，从物资采配、食材溯源、食堂监管等多个方面入手，助力构建严密高效、社会共治的食品安全治理体系，减轻监管负担，降低食品安全风险。"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/solution/e-ms-bureau'
        }]
	},

    //关于我们
    "/about/companies-introduce":{//企业介绍
		title: '企业介绍-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "华略、valuetek、渝教集团、重庆食堂"
		},{
			name: "description",
			content: "华略未来科技（重庆）有限公司是一家基于信息技术与人工智能的智慧食安方案提供商，位于中国.重庆。企业专注于食品安全领域，稳健经营、持续创新、开放合作，在智慧食品安..."
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/about/companies-introduce'
        }]
	},//
    "/about/social-responsibility":{//社会责任
		title: '社会责任-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "华略社会责任、社会公益、华略扶贫、脱贫攻坚、精准扶贫、教育扶贫、农村营养餐"
		},{
			name: "description",
			content: "在实现企业高速发展的同时，始终不忘积极履行企业社会责任，积极投身于助学助教和扶贫等社会公益事业领域，为成千上万个家庭和个人带去了梦想和希望个人带去了梦想和希望。"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/about/social-responsibility'
        }]
	},//
    "/about/contact":{//联系方式
		title: '联系方式-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "华略联系方式、食安平台厂家"
		},{
			name: "description",
			content: "华略联系方式、食安平台厂家"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/about/contact'
        }]
	},//
    "/news/industry":{//行业资讯
		title: '行业资讯-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "食品安全行业信息、食品安全新闻"
		},{
			name: "description",
			content: "食品安全行业信息、食品安全新闻"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/news/industry'
        }]
	},//
    "/news/company":{//公司新闻
		title: '公司新闻-华略未来科技',
		meta: [
		{
			name: "keywords",
			content: "华略新闻"
		},{
			name: "description",
			content: "华略新闻"
		}],
        link: [
        {
            rel: 'canonical',
            href: 'http://www.valuetek.com.cn/news/company'
        }]
	},//


    /**
     * 当前页的MetaInfo（title keywords  description）
     */
    currentMetaInfo(path){
        let metaInfo={
            title: 'AI智慧食堂-食品溯源-生鲜食材配送-校园食品安全-华略未来科技',
            meta: [
            {
                name: "keywords",
                content: "AI食堂,智慧食堂,食品溯源,生鲜配送,食材配送,校园食品安全"
            },{
                name: "description",
                content: "华略未来科技有限公司是一家基于信息技术与人工智能的食安方案提供商,企业专注于AI智慧食堂,食品溯源,食材配送,生鲜配送,校园食品安全等,为客户,监管部门提供极具竞争力的产品方案和服务."
            }],
            link: [
            {
                rel: 'canonical',
                href: 'http://www.valuetek.com.cn/'
            }]
        };
        if(metaInfoUtils[path]!=undefined){
            metaInfo=metaInfoUtils[path];
        }
        return metaInfo;
    },
}


export default metaInfoUtils;
